import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-import-modal',
  templateUrl: './delete-import-modal.component.html',
  styleUrls: ['./delete-import-modal.component.scss']
})
export class DeleteImportModalComponent {

  constructor() { }

}
